import React from 'react';
import styled from 'styled-components';
import { SectionParent, B1, H2, H1 } from '../../StyledComponents';
import Deploy from '../../../assets/v2/androidx86/group-90.svg';
import Lock from '../../../assets/v2/androidx86/group-29.svg';
import Remote from '../../../assets/v2/androidx86/group-38.svg';
import { BottomBanner } from '../BottomBanner';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import HardwareForm from '../../../templates/hardwareComponents/OdroidSectionFour';

const Section = styled(SectionParent)`
  background: #ffffff;
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    padding-bottom: 5rem !important;
    background: #fafcff;
  }
`;

const SectionHeading = styled(H1)`
  text-align: center;
  color: #4a5376;
  grid-column: span 12;
  @media (max-width: 520px) {
    font-size: 28px;
  }
`;

const Grid = styled.div`
  display: grid;
  margin-top: 3rem;
  @media (min-width: 520px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 520px) {
    margin-top: 2rem;
  }
`;

const GridItem = styled.div`
  justify-self: start;
  max-width: 100%;
  grid-column: span 2;
  align-self: center;
  padding-bottom: 2rem;
  @media (max-width: 768px) {
    margin-left: 5rem;
  }
  @media (max-width: 520px) {
    grid-column: span 1;
    margin-bottom: 5rem;
    display: grid;
    margin-left: 0rem;
    justify-items: center;
  }
`;
const GridItemRight = styled.div`
  justify-self: center;
  max-width: 100%;
  grid-column: span 2;
  align-self: center;
  padding-bottom: 2rem;
  @media (max-width: 768px) {
    margin-right: 5rem;
  }
  @media (max-width: 520px) {
    grid-column: span 1;
    margin-bottom: 5rem;
    display: grid;
    margin-right: 0rem;
    justify-items: center;
  }
`;
const FounderName = styled(H2)`
  padding-top: 2rem;
  @media (max-width: 520px) {
    text-align: left;
  }
  font-size: 24px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.92;
  letter-spacing: normal;
  color: #4d3df4;
`;

const SectionLeftImage = styled(LazyLoadImage)`
  max-width: 250px;
  width: 80%;
  justify-self: end;
  @media (max-width: 520px) {
    margin-left: 0rem;
  }
`;
const FounderImgShiv = styled(LazyLoadImage)`
  max-width: 250px;
  width: 80%;
  justify-self: center;
  @media (max-width: 520px) {
    display: none;
  }
`;
const FounderImgMobile = styled(LazyLoadImage)`
  width: 80%;
  justify-self: center;
  margin-left: 1rem;
  @media (min-width: 521px) {
    display: none;
  }
`;
const SectionSubHeading = styled.div`
  padding-top: 1rem;

  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #26315c;
  @media (max-width: 520px) {
    text-align: center;
  }
`;
const SectionSubHeadingRight = styled.div`
  padding-top: 1rem;

  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  text-align: left;
  padding-left: 6rem;
  line-height: normal;
  letter-spacing: normal;
  color: #26315c;
  @media (max-width: 520px) {
    text-align: center;
    padding-left: 0rem;
  }
`;

const SectionContent = styled(B1)`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.61;
  letter-spacing: normal;
  width: 80%;
  color: #6a718c;

  padding-top: 0.5rem;
  text-align: justify;
  img {
    margin-top: 1rem;
  }
  @media (max-width: 520px) {
    text-align: justify;
    width: 90%;
  }
`;

const FounderExpShiv = styled(B1)`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.61;
  letter-spacing: normal;
  width: 100%;
  padding-left: 6rem;
  color: #6a718c;
  padding-top: 0.5rem;
  text-align: justify;
  img {
    margin-top: 1rem;
  }
  @media (max-width: 520px) {
    padding-left: 0;
    text-align: justify;
    width: 90%;
  }
`;

const ImgWrapper = styled.div`
  display: grid;
  align-items: center;
  padding-right: 3rem;
  @media (max-width: 520px) {
    gitppadding-right: 4rem;
  }
`;

export const Modal = styled.div`
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
`;

export const ModalContent = styled.div`
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
  max-width: 860px;
`;
export default class HardwareSectionOne extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }
  OpenModal = (event: any) => {
    event.stopPropagation();
    const modal = document.getElementById('myModal');
    if (modal !== null) {
      modal.style.display = 'block';
    }
  };
  CloseModal = (event: any) => {
    const modal = document.getElementById('myModal');
    if (modal !== null) {
      modal.style.display = 'none';
    }
  };
  render() {
    return (
      <div>
        <Modal id="myModal" className="modal">
          <ModalContent className="modal-content">
            <span
              className="close"
              onClick={this.CloseModal}
              style={{
                display: 'grid',
                justifyContent: 'end',
                cursor: 'pointer',
              }}
            >
              &times;
            </span>
            <HardwareForm formId="android_x86_form" />
          </ModalContent>
        </Modal>

        <Section>
          <SectionHeading>Benefits of Esper on x86 Hardware</SectionHeading>
          <Grid>
            <ImgWrapper>
              <SectionLeftImage
                src={Deploy}
                alt="Extend Your x86 Installed Base"
              />
            </ImgWrapper>
            <GridItem>
              <SectionSubHeading>
                Extend Your x86 Installed Base
              </SectionSubHeading>
              <SectionContent>
                Extend the life of your Windows-based x86 hardware and increase
                ROI by migrating them to Android, rather than replacing them due
                to Windows EOL
              </SectionContent>
            </GridItem>
          </Grid>
          <Grid>
            <GridItemRight>
              <FounderImgMobile
                src={Lock}
                alt="
            Best Hardware Economics "
              />
              <SectionSubHeadingRight>
                Best Hardware Economics
              </SectionSubHeadingRight>
              <FounderExpShiv>
                Get the best of both worlds, the economics of the smartphone
                industry for mobile solutions and the superior
                price-to-performance of x86 for power-based systems.
              </FounderExpShiv>
            </GridItemRight>
            <ImgWrapper>
              <FounderImgShiv src={Lock} alt="Remote Control and Debugging" />
            </ImgWrapper>
          </Grid>
          <Grid>
            <ImgWrapper>
              <SectionLeftImage
                src={Remote}
                alt="Enhanced Security and Management "
              />
            </ImgWrapper>
            <GridItem>
              <SectionSubHeading>
                Enhanced Security and Management
              </SectionSubHeading>
              <SectionContent>
                Secure remote debugging of devices in the field, remote control
                and remote view, and take advantage of fine-grained fleet
                control
              </SectionContent>
            </GridItem>
          </Grid>
        </Section>
        <BottomBanner
          description={
            'x86 can now run on Android and here’s how Enterprises will benefit'
          }
          buttonText={'Talk to us about Android x86'}
          buttonAction={this.OpenModal}
        />
      </div>
    );
  }
}
